module.exports = __webpack_public_path__ + "fonts/dm-sans-v10-latin-500.929fc41.woff";